"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDrawing;
var _react = require("react");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var initialConfig = {
  type: null,
  id: null,
  name: null,
  anchor: {}
};
function useDrawing() {
  var _useState = (0, _react.useState)(initialConfig),
    _useState2 = _slicedToArray(_useState, 2),
    config = _useState2[0],
    setConfig = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDrawing = _useState4[0],
    setIsDrawing = _useState4[1];
  var getBoundingBox = function getBoundingBox(pointA, pointB) {
    // return the upper-left (UL) and lower-right (LR) points

    return {
      UL: {
        x: Math.min(pointA.x, pointB.x),
        y: Math.min(pointA.y, pointB.y)
      },
      LR: {
        x: Math.max(pointA.x, pointB.x),
        y: Math.max(pointA.y, pointB.y)
      }
    };
  };
  var getShapeAttributes = (0, _react.useCallback)(function (position, type) {
    var _ref, _config$type;
    var attrs;
    var shapeType = (_ref = (_config$type = config === null || config === void 0 ? void 0 : config.type) !== null && _config$type !== void 0 ? _config$type : type) !== null && _ref !== void 0 ? _ref : "Rect";
    var id = config.id,
      name = config.name,
      anchor = config.anchor;
    switch (shapeType) {
      case "Circle":
        attrs = {
          point: position
        };
        break;
      case "Line":
        attrs = {
          start: anchor,
          finish: position
        };
        break;
      case "Rect":
      case "Ellipse":
      default:
        attrs = getBoundingBox(anchor, position);
        break;
    }
    return _objectSpread({
      type: shapeType,
      id: id,
      name: name
    }, attrs);
  }, [config]);
  var setDrawingConfig = (0, _react.useCallback)(function () {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (Object.keys(obj).length > 0) {
      setConfig(function (shape) {
        return _objectSpread(_objectSpread({}, shape), obj);
      });
    }
  }, []);
  var onDrawingClick = (0, _react.useCallback)(function (position, callback) {
    var shape = config.type;
    if (!shape) return;
    if (shape === "Circle") {
      var attrs = getShapeAttributes(position, "Circle");
      callback === null || callback === void 0 ? void 0 : callback(attrs);
      setIsDrawing(false);
      setConfig(function (_ref2) {
        var type = _ref2.type;
        return {
          type: type
        };
      });
    } else {
      setDrawingConfig({
        anchor: position
      });
      setIsDrawing(function (prev) {
        return !prev;
      });
    }
  }, [config, setDrawingConfig, getShapeAttributes]);
  var onDrawingMove = (0, _react.useCallback)(function (position, callback) {
    if (isDrawing) {
      var attrs = getShapeAttributes(position);
      callback === null || callback === void 0 ? void 0 : callback(attrs);
    }
  }, [getShapeAttributes, isDrawing]);
  (0, _react.useEffect)(function () {
    // reset the config if isDrawing is set to false
    if (isDrawing === false) {
      // clear everything but the active marker
      setConfig(function (_ref3) {
        var type = _ref3.type;
        return {
          type: type
        };
      });
    }
  }, [isDrawing]);
  return {
    isDrawing: isDrawing,
    setDrawingConfig: setDrawingConfig,
    getShapeAttributes: getShapeAttributes,
    onDrawingClick: onDrawingClick,
    onDrawingMove: onDrawingMove
  };
}